module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/userprofile/userprofile-grid/userprofile-grid.component.css
// module id = ./src/app/master/userprofile/userprofile-grid/userprofile-grid.component.css
// module chunks = main